import { IRouteProps } from "components/Router/Router";
import { HOMEPAGE_ROUTE } from "constants/router";
import AuthLayout from "Layouts/auth/index";
import React from "react";
import { Redirect, Route } from "react-router-dom";
const AuthRoute: React.FC<IRouteProps> = ({
  component: Component,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => (
        <AuthLayout>
          {true ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: HOMEPAGE_ROUTE,
                state: { from: props.location },
              }}
            />
          )}
        </AuthLayout>
      )}
    />
  );
};
export default AuthRoute;
